module.exports = __webpack_public_path__ + "img/hand-holding-phone.b67913f8.jpg";